import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAccessibleModuleTiles } from '../../../hooks/useAccessibleModuleTiles';
import './moduleLauncher.css';

const ModuleLauncher = ({ open, onClose, activeModuleTitle, highlightDashboard }) => {
  const panelRef = useRef(null);
  const { tiles, loading } = useAccessibleModuleTiles(true);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    const onPointerDown = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        // Keep open when clicking the apps-grid trigger (handled by header)
        if (e.target.closest?.('.nav-apps-grid')) return;
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('mousedown', onPointerDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('mousedown', onPointerDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      ref={panelRef}
      className="module-launcher"
      role="dialog"
      aria-label="Modules"
      aria-modal="false"
    >
      <div className="module-launcher__title">Modules</div>
      {loading && tiles.length === 0 ? (
        <div className="module-launcher__loading">Loading…</div>
      ) : (
        <div className="module-launcher__grid">
          {tiles.map((tile) => {
            const isActive =
              tile.key === 'dashboard'
                ? !!highlightDashboard
                : activeModuleTitle === tile.title;
            return (
              <Link
                key={tile.key}
                to={tile.to}
                className={`module-launcher__tile${isActive ? ' is-active' : ''}${
                  tile.locked ? ' is-locked' : ''
                }`}
                onClick={onClose}
                title={
                  tile.locked
                    ? 'This module is not available in your current subscription plan.'
                    : tile.title
                }
              >
                <span className="module-launcher__icon">
                  {tile.iconStyle || <i className={tile.iconClass} aria-hidden="true" />}
                  {tile.locked ? (
                    <i className="fas fa-lock module-launcher__lock" aria-hidden="true" />
                  ) : null}
                </span>
                <span className="module-launcher__label">{tile.label}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ModuleLauncher;
